export default __webpack_public_path__ + "static/media/funky3.49ed1455.jpg";